<script setup lang="ts">
// Coquille minimale, volontairement.
//
// Chaque vue V4 s'enveloppe elle-même dans `V4Layout` (sidebar 212 px, header
// sticky, sélecteur de marque, toggle de thème). Ajouter ici un en-tête à moi
// dédoublerait la navigation — c'est exactement l'erreur que je viens de
// corriger : j'avais fabriqué une interface au lieu de porter la vôtre.
import { RouterView } from 'vue-router';
import { installerLangue } from './composables/langue.composable';

// La langue de la personne, une fois pour toute l'application (8 octobre 2026).
installerLangue();
</script>

<template>
  <RouterView />
</template>
